<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box full-width-reading">


                        <div class="document top98 contact">
                            <div class="row">
                                <div class="col-12">
                                    <h2>Contact Us</h2>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <p>The Ministry of Labour and Home Affairs</p>
                                    <p>Department of immigration and Citizenship<br />P. O. Box 942<br />Gaborone</p>
                                    <p />
                                    <p>TELEPHONE: +267 3611327/40/43/44</p>
                                    <p>FAX: + 267 392 4719/ +267 3900005</p>
                                    <p><u>E-mail Addresses</u> </p>
                                    <p>General Enquiries: <a href="mailto:immigration-admin@gov.bw">immigration-admin@gov.bw</a></p>
                                    <p>Technical Support: <a href="mailto:evisa-support@gov.bw">evisa-support@gov.bw</a></p>
                                </div>

                                <div class="col-6">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3625.9575086275154!2d25.909457751173385!3d-24.659590884071235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x15cf43ddc03fe128!2sDepartment%20of%20Immigration%20%26%20Citizenship!5e0!3m2!1sen!2sil!4v1609324324871!5m2!1sen!2sil" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <h2>Contact Us</h2>
                </div>
            </div>

            <div class="row">
                <div class="col-12 contact-us-small-text">
                    <p>MINISTRY OF NATIONALITY, IMMIGRATION AND GENDER AFFAIRS</p>
                    <p>Department of immigration and Citizenship<br />P. O. Box 942<br />Gaborone</p>
                    <p />
                    <p>TELEPHONE: +267 3611300/02</p>
                    <p>FAX: + 267 3914286/ +267 3914286</p>
                    <p>E-mail: <a href="mailto:immigration-admin@gov.bw">immigration-admin@gov.bw</a></p>
                </div>

                <div class="col-12">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3625.9575086275154!2d25.909457751173385!3d-24.659590884071235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x15cf43ddc03fe128!2sDepartment%20of%20Immigration%20%26%20Citizenship!5e0!3m2!1sen!2sil!4v1609324324871!5m2!1sen!2sil" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'Contact',

        model: {},
        data: () => ({

        }),
        mounted() {


        },
        computed: {

        },
        methods: {
        }
    }
</script>

<style scoped>
</style>